module.exports = "\n<router-outlet>\n    <!-- <app-spinner></app-spinner> -->\n    <ngx-ui-loader></ngx-ui-loader>\n</router-outlet>"